import LocomotiveScroll from 'locomotive-scroll';
import { toggleScrolledHeader } from './_header';

const videoScaleBreakpoint = .17;
const options = {
	el: document.querySelector('[data-scroll-container]'),
	smooth: true
};

let videoScaleState = 0;

if (window.innerWidth >= 1024) {
	const lscroll = new LocomotiveScroll(options);


	lscroll.on('scroll', (args) => {
		toggleScrolledHeader();

		if (typeof args.currentElements['first'] === 'object') {
			const progress: number = args.currentElements['first'].progress;
			const el: HTMLImageElement = args.currentElements['first'].el;

			if (progress < .3) {
				el.style.setProperty('--block-opacity', '1');
			}

			if (progress >= .3) {
				const scale = Math.abs(Math.min((progress - .3) / .3, 1) - 1);
				el.style.setProperty('--block-opacity', String(scale));
			}
		}

		if (typeof args.currentElements['second'] === 'object') {
			const progress: number = args.currentElements['second'].progress;
			const el: HTMLImageElement = args.currentElements['second'].el;

			if (progress < .35) {
				el.style.setProperty('--block-opacity', '0');
			}

			if (progress >= .35) {
				const scale = Math.abs(Math.min((progress - .35) / .5, 1));
				el.style.setProperty('--block-opacity', String(scale));
			}
		}

		if (typeof args.currentElements['video'] === 'object') {
			const progress: number = args.currentElements['video'].progress;
			const el: HTMLVideoElement = args.currentElements['video'].el;
		
			if (progress < videoScaleBreakpoint) {
				el.style.setProperty('--video-scale', '0');
			
				if (!el.paused) {
					el.pause();
				}

				videoScaleState = 0;
			}

			if (progress >= videoScaleBreakpoint) {
				const scale = Math.min((progress - videoScaleBreakpoint) / .45, 1);
				el.style.setProperty('--video-scale', String(scale));

				if (scale >= 0.5 && el.paused) {
					el.play();
				} else if (scale < 0.5 && !el.paused) {
					el.pause();
				}

				videoScaleState = scale;
			}
		}
	});

	document.querySelectorAll('[data-role=scroll-to-anchor]').forEach(
		(node) => node.addEventListener('click', () => {
			if (videoScaleState <= .85) {
				lscroll.scrollTo('[data-role=scroll-anchor]');
			} else {
				lscroll.scrollTo('#section-hb');
			}
		})
	);
} else {
	const $video = document.querySelector('[data-scroll-id=video]') as HTMLVideoElement;

	$video?.setAttribute('autoplay', 'true');
	$video?.play();

	window.addEventListener('scroll', () => toggleScrolledHeader());
}